/* eslint-disable no-param-reassign */

function setImage(images, currentImg, imgIndex) {
  images.forEach((el, index) => {
    if (parseInt(imgIndex, 10) === index + 1) {
      currentImg.src = el.getAttribute('data-src');
      currentImg.alt = el.alt;
    }
  });
}

function changeIndex(navLinks, linkIndex) {
  navLinks.forEach((el, index) => {
    if (el.classList.contains('is-active')) el.classList.remove('is-active');
    index += 1;
    if (linkIndex === index) {
      el.classList.add('is-active');
    }
  });
}

const gallery = () => {
  const galleryModal = document.querySelector('.js-gallery-modal');
  const images = document.querySelectorAll('.js-gallery-items img');
  const currentImg = document.querySelector('.js-gallery-current-img');
  const close = document.querySelector('.js-gallery-close');
  const navLinks = document.querySelectorAll('.js-gallery-link');
  const prev = document.querySelector('.js-gallery-prev');
  const next = document.querySelector('.js-gallery-next');
  const largeImages = document.querySelectorAll('.js-gallery-item-img');
  let activeIndex = null;

  if (images && currentImg) {
    images.forEach((el, index) => {
      el.addEventListener('click', () => {
        galleryModal.classList.add('is-active');
        currentImg.src = largeImages[index].getAttribute('data-src');
        currentImg.alt = largeImages[index].alt;
        changeIndex(navLinks, (activeIndex = index + 1));
      });
    });
  }
  if (close) {
    close.addEventListener('click', event => {
      event.preventDefault();
      galleryModal.classList.remove('is-active');
    });
  }
  if (navLinks && prev && next) {
    navLinks.forEach((el, index) => {
      el.addEventListener('click', event => {
        event.preventDefault();
        setImage(largeImages, currentImg, index + 1);
        changeIndex(navLinks, (activeIndex = index + 1));
      });
    });
    prev.addEventListener('click', event => {
      event.preventDefault();
      if (activeIndex !== 1) {
        activeIndex -= 1;
        setImage(largeImages, currentImg, activeIndex);
        changeIndex(navLinks, activeIndex);
      }
    });
    next.addEventListener('click', event => {
      event.preventDefault();
      if (activeIndex !== navLinks.length) {
        activeIndex += 1;
        setImage(largeImages, currentImg, activeIndex);
        changeIndex(navLinks, activeIndex);
      }
    });
  }
};

export default gallery;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/gallery.js